module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Black-Hestia.e44248f.eot";